import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO_URL } from "@/lib/api";

const NAV = [
  { to: "/bookstore", label: "Bookstore" },
  { to: "/authors", label: "Authors" },
  { to: "/services", label: "Publishing" },
  { to: "/tcpi", label: "TCPI" },
  { to: "/foundation", label: "Foundation" },
  { to: "/academy", label: "Academy" },
  { to: "/media", label: "Media" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 border-b border-navy/10 bg-white/85 backdrop-blur-md"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="header-logo-link">
          <img
            src={LOGO_URL}
            alt="1123 Publishing Company Logo"
            className="h-12 w-12 object-cover border border-navy/15"
          />
          <div className="hidden sm:flex flex-col leading-tight">
            <span className="font-serif text-lg text-navy">1123 Publishing</span>
            <span className="overline text-[10px]">Company &middot; Est. Legacy</span>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-[12px] tracking-[0.22em] uppercase font-medium transition-colors ${
                  isActive ? "text-gold" : "text-navy hover:text-gold"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/submit"
            data-testid="header-submit-cta"
            className="hidden md:inline-block bg-navy text-ivory px-5 py-3 text-[11px] uppercase tracking-[0.22em] font-medium hover:bg-charcoal transition-colors"
          >
            Submit Manuscript
          </Link>
          <button
            type="button"
            className="lg:hidden p-2 text-navy"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
            data-testid="header-mobile-toggle"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-navy/10 bg-white" data-testid="mobile-menu">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                className="text-sm uppercase tracking-[0.2em] text-navy py-2"
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </Link>
            ))}
            <Link
              to="/submit"
              onClick={() => setOpen(false)}
              className="bg-navy text-ivory px-5 py-3 text-xs uppercase tracking-[0.22em] text-center mt-2"
            >
              Submit Manuscript
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
